module.exports = __webpack_public_path__ + "img/tennisdoubles.25ffc64b.svg";